
import {createContext, useContext, useReducer } from "react";

 export const UserContext         = createContext(null);
 export const UserDispatchContext =  createContext(null);

 export function UserProvider({children}) {

    let initUserSetting = {
        location: {}
    }

    const [userSetting, dispatch] = useReducer(userReducer,initUserSetting);

    return(
        <UserContext value={userSetting}>
            <UserDispatchContext value={dispatch}>
                {children}
            </UserDispatchContext>
        </UserContext>
    )
 }


 export function useUser()        {return useContext(UserContext)};
 export function useUserDispatch() {return useContext(UserDispatchContext)};


 function userReducer(userSetting,action) {
    let newSetting;

    switch(action.type) {

        case 'upd_loc':
            userSetting.location = {
                lng: action.oLocation.lng,
                lat: action.oLocation.lat
            }
        break;

        default: //
    }

    return(userSetting);
 }